<div class="flex justify-between gap-5">
  <div class="flex flex-col">
    <div class="flex items-center">
      <a [routerLink]="[pageReturnURL]" class="text-2xl flex-shrink-0 hover:text-primary mr-2">
        <rkt-icon name="arrow-left"></rkt-icon>
      </a>
      <div class="h-8 flex items-center">
        <div class="animate-pulse bg-[#E6E6E6] h-6 w-72 rounded-md"></div>
      </div>

      @if (withStatus) {
        <div class="animate-pulse ml-3 bg-[#E6E6E6] h-[1.625rem] w-18 rounded-full"></div>
      }
    </div>

    <div class="animate-pulse flex items-center gap-3 mt-2 pl-8">
      <div class="bg-[#E6E6E6] h-5 w-32 rounded-md"></div>

      <div class="h-3 w-3 rounded-full bg-[#E6E6E6]"></div>

      <div class="bg-[#E6E6E6] h-5 w-24 rounded-md"></div>
    </div>
  </div>
</div>
